module.exports = __webpack_public_path__ + "static/img/i-a-o-right3.350b0dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i-a-o-right3.jpg
// module id = JoFZ
// module chunks = 5